import { render, staticRenderFns } from "./Dev.vue?vue&type=template&id=3944cddc&"
import script from "./Dev.vue?vue&type=script&lang=js&"
export * from "./Dev.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports